import { useSyncExternalStore } from "react";
import { getLocale, subscribeLocale } from "./runtime";

export function useLocale(): string {
  return useSyncExternalStore(subscribeLocale, getLocale, () => "en");
}
